import React, { useEffect, useState } from "react";
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import {
  BiPlus,
  BiEdit,
  BiTrash,
  BiBriefcase,
  BiStar
} from "react-icons/bi";

const ManageJobs = () => {

  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const token = localStorage.getItem("token");

  const [jobs, setJobs] = useState([]);
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [filter, setFilter] = useState("All");

  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);

  const [formData, setFormData] = useState({

    jobTitle: "",
    companyName: "",
    type: "Private",
    description: "",
    eligibility: "",
    selectionProcess: "",
    howToApplyDescription: "",
    trainingDescription: "",
    youtubeLink: "",
    officialLink: "",
    location: "",
    salary: "",
    experienceRequired: "",
    jobMode: "Online",
    numberOfVacancies: "",
    lastDateToApply: "",
    isFeatured: false

  });


  const role = localStorage.getItem("role");
  // decide endpoint based on role
  const endpoint =
    role === "subAdmin"
      ? `${API_BASE_URL}/subadmin/jobs`
      : `${API_BASE_URL}/admin/jobs`;

  /* ================= FETCH ================= */

  const fetchJobs = async () => {

    try {

      const res = await axios.get(endpoint, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setJobs(res.data.data);
      setFilteredJobs(res.data.data);

    } catch (err) {
      console.log(err);
    }

  };

  useEffect(() => {
    fetchJobs();
  }, []);


  /* ================= FILTER ================= */

  const handleFilter = (type) => {

    setFilter(type);

    if (type === "All")
      setFilteredJobs(jobs);

    else if (type === "Featured")
      setFilteredJobs(jobs.filter(j => j.isFeatured));

    else
      setFilteredJobs(jobs.filter(j => j.type === type));

  };


  /* ================= INPUT ================= */

  const handleChange = (e) => {

    const { name, value, type, checked } = e.target;

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value
    });

  };


  /* ================= CREATE / UPDATE ================= */

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      if (editId) {

        await axios.put(
          `${endpoint}/${editId}`,
          formData,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        alert("Job Updated");

      } else {

        await axios.post(
          endpoint,
          formData,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        alert("Job Created");

      }

      resetForm();
      fetchJobs();
      setShowForm(false);

    } catch (err) {

      console.log(err);
      alert("Error saving job");

    }

  };


  /* ================= EDIT ================= */

  const handleEdit = (job) => {

    setFormData(job);
    setEditId(job._id);
    setShowForm(true);

    window.scrollTo({ top: 0, behavior: "smooth" });

  };


  /* ================= DELETE ================= */

  const handleDelete = async (id) => {

    if (!window.confirm("Delete this job?")) return;

    await axios.delete(`${endpoint}/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });

    fetchJobs();

  };


  /* ================= RESET ================= */

  const resetForm = () => {

    setEditId(null);

    setFormData({

      jobTitle: "",
      companyName: "",
      type: "Private",
      description: "",
      eligibility: "",
      selectionProcess: "",
      howToApplyDescription: "",
      trainingDescription: "",
      youtubeLink: "",
      officialLink: "",
      location: "",
      salary: "",
      experienceRequired: "",
      jobMode: "Online",
      numberOfVacancies: "",
      lastDateToApply: "",
      isFeatured: false

    });

  };


  /* ================= UI ================= */

  return (

    <div style={styles.container}>


      {/* HEADER */}

      <div style={styles.header}>

        <h2 style={styles.title}>
          🚀 Manage Jobs
        </h2>

        <button
          style={styles.createBtn}
          onClick={() => {

            setShowForm(!showForm);
            resetForm();

          }}
        >
          <BiPlus size={20} />
          Create Job
        </button>

      </div>


      {/* FILTER */}

      <div style={styles.filterContainer}>

        {["All", "Private", "Government", "Featured"].map(f => (

          <button
            key={f}
            onClick={() => handleFilter(f)}
            style={{
              ...styles.filterBtn,
              background:
                filter === f
                  ? "#FF8103"
                  : "#fff",
              color:
                filter === f
                  ? "#fff"
                  : "#333"
            }}
          >
            {f}
          </button>

        ))}

      </div>


      {/* FORM */}

      {showForm && (

        <form onSubmit={handleSubmit} style={styles.form}>

          <h3>
            {editId ? "Update Job" : "Create Job"}
          </h3>

          <div style={styles.grid}>


            <input
              name="jobTitle"
              placeholder="Job Title"
              value={formData.jobTitle}
              onChange={handleChange}
              required
              style={styles.input}
            />

            <input
              name="companyName"
              placeholder="Company Name"
              value={formData.companyName}
              onChange={handleChange}
              style={styles.input}
            />

            <select
              name="type"
              value={formData.type}
              onChange={handleChange}
              style={styles.input}
            >
              <option>Private</option>
              <option>Government</option>
            </select>

            <input
              name="location"
              placeholder="Location"
              value={formData.location}
              onChange={handleChange}
              style={styles.input}
            />

          </div>


          <label>Description</label>

          <ReactQuill
            value={formData.description}
            onChange={(value) =>
              setFormData({
                ...formData,
                description: value
              })
            }
          />


          <div style={styles.grid}>

            <input
              name="youtubeLink"
              placeholder="Training YouTube Link"
              value={formData.youtubeLink}
              onChange={handleChange}
              style={styles.input}
            />

            <input
              name="officialLink"
              placeholder="Apply Link"
              value={formData.officialLink}
              onChange={handleChange}
              style={styles.input}
            />

            <input
              name="salary"
              placeholder="Salary"
              value={formData.salary}
              onChange={handleChange}
              style={styles.input}
            />

            <input
              type="date"
              name="lastDateToApply"
              value={formData.lastDateToApply}
              onChange={handleChange}
              style={styles.input}
            />

          </div>


          <label>

            <input
              type="checkbox"
              name="isFeatured"
              checked={formData.isFeatured}
              onChange={handleChange}
            />

            Featured Job

          </label>


          <button type="submit" style={styles.saveBtn}>
            {editId ? "Update Job" : "Create Job"}
          </button>

        </form>

      )}


      {/* JOB LIST */}

      <div style={styles.cardGrid}>

        {filteredJobs.map(job => (

          <div key={job._id} style={styles.card}>

            <BiBriefcase size={28} color="#FF8103" />

            <h4>{job.jobTitle}</h4>

            <p>{job.companyName}</p>

            <span>{job.location}</span>

            <div>

              <span style={styles.badge}>
                {job.type}
              </span>

              {job.isFeatured &&
                <BiStar color="gold" size={20} />
              }

            </div>


            <div style={styles.actions}>

              <BiEdit
                size={22}
                onClick={() => handleEdit(job)}
                style={styles.icon}
              />

              <BiTrash
                size={22}
                onClick={() => handleDelete(job._id)}
                style={styles.icon}
              />

            </div>

          </div>

        ))}

      </div>

    </div>

  );

};


export default ManageJobs;



/* ================= CSS ================= */

const styles = {

  container: {

    padding: 30,
    background: "#f4f6fb",
    minHeight: "100vh"

  },

  header: {

    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"

  },

  title: {

    fontWeight: "700"

  },

  createBtn: {

    background: "#FF8103",
    color: "#fff",
    border: "none",
    padding: "10px 18px",
    borderRadius: 8,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: 5

  },

  filterContainer: {

    marginTop: 20,
    marginBottom: 20

  },

  filterBtn: {

    padding: "8px 14px",
    marginRight: 10,
    borderRadius: 8,
    border: "1px solid #ddd",
    cursor: "pointer"

  },

  form: {

    background: "#fff",
    padding: 20,
    borderRadius: 12,
    marginBottom: 20

  },

  grid: {

    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 10

  },

  input: {

    padding: 10,
    borderRadius: 8,
    border: "1px solid #ddd"

  },

  saveBtn: {

    marginTop: 15,
    background: "#FF8103",
    color: "#fff",
    border: "none",
    padding: 12,
    borderRadius: 8,
    cursor: "pointer"

  },

  cardGrid: {

    display: "grid",
    gridTemplateColumns: "repeat(auto-fill,minmax(250px,1fr))",
    gap: 15

  },

  card: {

    background: "#fff",
    padding: 18,
    borderRadius: 12,
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)"

  },

  badge: {

    background: "#FF8103",
    color: "#fff",
    padding: "3px 8px",
    borderRadius: 6,
    fontSize: 12

  },

  actions: {

    marginTop: 10,
    display: "flex",
    gap: 10

  },

  icon: {

    cursor: "pointer"

  }

};
